import { SettingConst } from '@faire/web-api--source/types';

/**
 * Changes the caching TTL for non-RSC category pages to match RSC category pages
 */
export const UPDATE_FE_CATEGORY_PAGE_CACHING_250409 =
  'UPDATE_FE_CATEGORY_PAGE_CACHING_250409' as SettingConst<
    'UPDATE_FE_CATEGORY_PAGE_CACHING_250409',
    boolean,
    'RETAILER'
  >;
